<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
		
export default {
  name: 'App',
  data(){
	  return{
		  
	  }
  },
  methods:{
	  
	  isMobile() {
	       const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
	       if (flag) {
	         console.log('移动端打开')
		 	this.$router.push('/m');
	       } 
		//    else {
	    //      console.log('PC端打开')
		//  	this.$router.push('/hello');
	    //    }
	     }
  },
  created(){
	 this.isMobile();
	// this.ipad();
  }
  
}
</script>

<style>
	#app{
		margin-top: 0px;
	}
	
	body,html {
	    width: 100%;
	    height: 100%;
	  }
	  body{
	  margin: 0;
	  padding: 0;
	  list-style: none;
	  }
	  
	  
	.el-tabs__header.is-top{
		display: flex;
    justify-content: center;
	}
	
	.el-tabs__item .is-top{
		padding-left: 2em;
		
	}
	
	.el-tabs__item {
		font-size: 1rem !important;
	}
	
	.el-drawer{
		width:60% !important;
	}
	
	.el-tabs__nav-next, .el-tabs__nav-prev{
		font-size: 30px !important;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue